import React from "react";

import Flex from "./base/flex";
import { gold, white, maroon, black } from "./base/colors";

import { useContentContext } from "../context/content-context";

const StickyTab = () => {
  const { isHCP, language } = useContentContext();

  // Get the current url path.
  const currentPath = window.location.pathname.toLowerCase();

  const targetPath = isHCP ? "/hcp/contact-us" : "/get-updates-about-furoscix";

  // If the user is already on the target path, don't show the sticky.
  if (currentPath === targetPath || language === "esp") {
    return null;
  }

  return (
    <>
      {isHCP ? (
        // Want to display 2 stickies on HCP pages.
        <Flex
          as="div"
          position="fixed"
          zIndex="4"
          bottom={["236px", "509px", "325px"]}
          width="160px"
          borderTopLeftRadius="31px"
          borderBottomLeftRadius="31px"
          right="0"
          textAlign="right"
          boxShadow="0 3px 3px 0 rgba(0,0,0,0.168)"
          color={black}
          style={{
            transition: "right 0.3s ease-in-out",
            cursor: "pointer",
            flexDirection: "column",
          }}
        >
          <Flex
            as="div"
            position="relative"
            borderBottomLeftRadius="31px"
            borderTopLeftRadius="31px"
            backgroundColor={maroon}
          >
            <Flex
              as="a"
              padding="17px 6px 0 0"
              href={targetPath}
              color={white}
              style={{
                textDecoration: "none",
              }}
            >
              <p className="uppercase strong">
                Connect with a rep to get started with furoscix
              </p>
            </Flex>
          </Flex>
        </Flex>
      ) : (
        <Flex
          as="a"
          position="fixed"
          zIndex="4"
          bottom={["236px", "509px", "325px"]}
          width="160px"
          borderTopLeftRadius="31px"
          borderBottomLeftRadius="31px"
          backgroundColor={gold}
          right="0"
          padding="13px 6px 0 9px"
          textAlign="right"
          boxShadow="0 3px 3px 0 rgba(0,0,0,0.168)"
          href={targetPath}
          style={{
            textDecoration: "none",
          }}
          color={black}
        >
          <p className="uppercase strong ">
            Click here for FUROSCIX email updates
          </p>
        </Flex>
      )}
    </>
  );
};

export default StickyTab;
